module.exports = __webpack_public_path__ + "static/img/loginBg.b9eea99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/loginBg.png
// module id = QrzY
// module chunks = 13